import script from "./new.vue?vue&type=script&setup=true&lang=js"
export * from "./new.vue?vue&type=script&setup=true&lang=js"

import "./new.vue?vue&type=style&index=0&id=08bb137a&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\payment-system-admin-yuyooke\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08bb137a"]])

export default __exports__